"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetIsPhoneVerificationEnabled = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var user_1 = require("../user");
var useGetIsPhoneVerificationEnabled = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var userData = (0, user_1.useUser)().data;
    var _k = (0, useQuery_1.useQuery)({
        canRender: !!((_d = (_c = (_b = (_a = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _a === void 0 ? void 0 : _a.getOne) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.location) === null || _d === void 0 ? void 0 : _d.country),
        path: keys_1.IS_PHONE_VERIFICATION_ENABLED,
        payload: {
            country: (_j = (_h = (_g = (_f = (_e = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _e === void 0 ? void 0 : _e.getOne) === null || _f === void 0 ? void 0 : _f.profile) === null || _g === void 0 ? void 0 : _g.location) === null || _h === void 0 ? void 0 : _h.country) === null || _j === void 0 ? void 0 : _j.toUpperCase(),
        },
        onErrorRetry: function () { return false; },
    }), data = _k.data, error = _k.error, isLoading = _k.isLoading;
    return (0, react_1.useMemo)(function () {
        var _a;
        return ({
            data: (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.enabled,
            isLoading: isLoading,
            error: error,
        });
    }, [data, isLoading, error]);
};
exports.useGetIsPhoneVerificationEnabled = useGetIsPhoneVerificationEnabled;
